import React from 'react'
import { styled } from 'styletron-react'
import { padding, border, borderStyle, margin } from 'lostyle'
import { media, sizes, palette, pseudo } from '../../style'

class Anchor extends React.Component {
  state = {
    hover: false
  }
  handleHover = event => {
    this.setState(state => ({ hover: !state.hover }))
  }
  render() {
    return (
      <A 
        $hover={this.state.hover} 
        onMouseEnter={this.handleHover} 
        onMouseLeave={this.handleHover} 
        {...this.props}
      >
        {this.props.children}
      </A>
    )
  }
}
const A = styled('a', ({ $hover }) => ({
  textDecoration: 'none',
  display: 'inline-block',
  position: 'relative',
  transition: 'color 0.25s ease-in-out',
  color: palette.colors.purple,
  zIndex: '0',
  ':hover': {
    color: palette.colors.red,
  },
  ':after': {
    content: '""',
    height: '2px',
    display: 'block',
    transition: 'width 0.25s ease-in-out, background 0.25s ease-in-out',
    width: $hover ? '100%' : '0%',
    background: $hover ? palette.colors.skin : palette.colors.lightPurple,
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: '-1',
    bottom: '3px',
    ...media('tablet', {
      bottom: '5px',
    })
  },
  ':before': {
    content: '""',
    height: '1px',
    display: 'block',
    transition: 'width 0.25s ease-in-out, background 0.25s ease-in-out',
    width: '100%',
    // borderBottom: `1px solid ${$hover ? palette.colors.lightRed : palette.colors.lightPurple}`,
    ...border({
      width: { bottom: '1px' },
      style: { bottom: 'solid' },
      color: { bottom: $hover ? palette.colors.lightRed : palette.colors.lightPurple }
    }),
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: '-1',
    bottom: '4px',
    ...media('tablet', {
      ...borderStyle({ bottom: 'dotted' }),
      bottom: '6px',
    })
  },
}))
A.displayName = 'A'

export default Anchor


// WEBPACK FOOTER //
// ./src/components/A/index.js